<template>
  <!--====== APPIE HEADER PART START ======-->


  
        <div class="row mt-4">
          <div class="mobilediv">
   

    <div class="mobile-header ">
      <span class="mobile-title" v-html="titleWordd"></span>
      <button class="toggle-btn" @click="toggleMenu">
        <i class="fa fa-bars"></i>
      </button>
    </div>

    <div class="sidebar" :class="{ 'sidebar-open': isMenuOpen }">
            <div class="title mt-3">
            <span v-html="titleWordd" ></span>
            <!-- <br> -->
              <hr>
            </div>

            <ul v-for="(item, index) in menuItems" :key="index" style="cursor: pointer" >
              <!--                              <router-link style="text-transform: capitalize;" v-if="item.path" :to="item.path">{{item.name}}</router-link>-->
              <!--                              {{item}}-->
              <li v-if="item.path == '/home-page'" class="menuliststyle "   @click="OpenModal(item.path,'home')">
                <a class="menutextstyle" v-if="item.path"
                   :to="item.path"><i class="fa fa-home faviconstyle"></i>  {{ item.name }}</a>

              </li>
              <li v-else-if="item.path == '/contact'" class="menuliststyle " v-b-modal.modal-center1   @click="OpenModal(item.path, 'custCare')">
                <a  class="menutextstyle faviconstyle " v-if="item.path"
                   :to="item.path">

                  📞 {{ item.name }}</a>

              </li>
              <li v-else>
                <ul>
                  <li v-for="(item ,index) in side.list" :key="index"  :class="item.url !='change_mobile_number'?'menuliststyle fontunset':''"   @click="ProfileMenuOpen(item.activity,item.url)">

                    <a  class="menutextstyle fontunset" v-if="item.url !='change_mobile_number'"
                     ><img :src="item.icon"
                                                                             style="width: 30px;margin-right: 4px;">
                      <span v-html="item.title"></span></a>

                  </li>
                </ul>
              </li>
            </ul>
          </div>

          </div>

          <div class="col-12 menudivfixed">
            <div class="title mt-3">
            <span v-html="titleWordd" ></span>
              <hr>
            </div>

            <ul v-for="(item, index) in menuItems" :key="index" style="cursor: pointer" >
              <!--                              <router-link style="text-transform: capitalize;" v-if="item.path" :to="item.path">{{item.name}}</router-link>-->
              <!--                              {{item}}-->
              <li v-if="item.path == '/home-page'" class="menuliststyle "   @click="OpenModal(item.path,'home')">
                <a class="menutextstyle" v-if="item.path"
                   :to="item.path"><i class="fa fa-home faviconstyle"></i>  {{ item.name }}</a>

              </li>
              <li v-else-if="item.path == '/contact'" class="menuliststyle " v-b-modal.modal-center1   @click="OpenModal(item.path, 'custCare')">
                <a  class="menutextstyle faviconstyle " v-if="item.path"
                   :to="item.path">

                  📞 {{ item.name }}</a>

              </li>
              <li v-else>
                <ul>
                  <li v-for="(item ,index) in side.list" :key="index"  :class="item.url !='change_mobile_number'?'menuliststyle fontunset':''"   @click="ProfileMenuOpen(item.activity,item.url)">

                    <a  class="menutextstyle fontunset" v-if="item.url !='change_mobile_number'"
                     ><img :src="item.icon"
                                                                             style="width: 30px;margin-right: 4px;">
                      <span v-html="item.title"></span></a>

                  </li>
                </ul>
              </li>
            </ul>
          </div>




        </div>



  <!--====== APPIE HEADER PART ENDS ======-->
</template>

<script>
// import NavItems from '../NavItems.vue'
import CryptoJS from "crypto-js";
import {common} from "@/common";

console.log(common().baseUrl)
export default {

  props: {


    side: {
      type: Object,
      required: true,
    },
    titleWordd: {
      type: String,
      required: true,
    },

    // title:{
    //   type:Object,
    //   required:true,
    // },

    menuItems: {
      type: Array,
      required: true,
    },
    nasted: {
      type: Boolean,
      default: true
    },
  },

  // components: { NavItems },

  data() {
    return {
      // title:'',
      isMenuOpen: false,

    }
  },

  mounted() {
    // document.addEventListener('scroll', this.stickMenu)
  },
  watch: {
    isMenuOpen(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden'; // Disable scrolling on the body
        document.body.style.position = 'fixed'; // Prevent scrolling further
      } else {
        document.body.style.overflow = ''; // Enable scrolling
        document.body.style.position = ''; // Restore default position
      }
    },
  },
  methods: {
    resetBodyStyles() {
      // Restore default body scrolling behavior
      document.body.style.overflow = '';
      document.body.style.position = '';
    },

    toggleMenu() {
      // alert('in')
      this.isMenuOpen = !this.isMenuOpen;
    },
    async OpenModal(menu, customerCare) {
      this.isMenuOpen = false;
      this. resetBodyStyles();
      // alert(menu)
      if (menu == '/home-page') {
        await this.$router.push(menu)
      } else if (menu == '/contact') {
        this.custCareDetails = customerCare;
        this.$bvModal.hide('modal-center1');
      }
      // console.log(customerCare)

    },

    async ProfileMenuOpen(activity, url) {

      this.isMenuOpen = false;
      this. resetBodyStyles();
      // alert(activity)
      // alert(url)

      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      // alert(lastPart);
      this.urlData = url;
      if (lastPart === 'Employer_Dynamic_Job_View') {

        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/post-view?page=${encodeURIComponent(encryptedString)}`);
      } else if (lastPart === 'ViewCandidate_List') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/viewed-employer-list?page=${encodeURIComponent(encryptedString)}`);
      } else if (lastPart === 'Employer_Company_Register') {

        if(url=='https://jobspro.nithrajobs.com/api/upload/Form/Fields'){
          const encryptedString = this.encryptUrl(url);
          await this.$router.push(`/kyc-register?page=${encodeURIComponent(encryptedString)}`);
        }
        else{
          const encryptedString = this.encryptUrl(url);
          await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
        }


      }
      else if (lastPart === 'MainActivity') {
        localStorage.removeItem('customerCare')
        localStorage.removeItem('token')
        localStorage.removeItem('titleWord')
        localStorage.removeItem('SideMenu')
        localStorage.removeItem('homeurl')
        localStorage.removeItem('profileData')
        localStorage.removeItem('carousel')
        await this.$router.push('/');

      }
      else if (lastPart === 'Employer_Register_Activity') {
        // await this.$router.push('/change-mobile-number');

      }
      else if (lastPart === 'Employer_Common_Webview_Activity') {
           const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/plan-purchase?page=${encodeURIComponent(encryptedString)}`)
        // window.open(this.url, '_blank');
      }
     
      // MainActivity logout
      // Employer_Register_Activity  mobilenum


    },
    encryptUrl(url) {
      const ciphertext = CryptoJS.AES.encrypt(url, 'secret key 123').toString();
      return ciphertext;
    },
    decryptUrl(ciphertext) {
      const bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
      const originalUrl = bytes.toString(CryptoJS.enc.Utf8);
      return originalUrl;
    },

    Encrypt(str) {
      // return str.split('').map(char => char.charCodeAt(0)).join('-');
      return str.replace(/[a-zA-Z]/g, function (char) {
        // Replace each alphabetic character with its encrypted value
        const charCode = char.charCodeAt(0);
        const encryptedCharCode = charCode + 1; // You can use a different encryption logic
        return String.fromCharCode(encryptedCharCode);
      });
    },

    showSidebar(e) {
      this.$emit("toggleSidebar", e)
    },
    // stickMenu() {
    //   const result = document.querySelector('.appie-sticky')
    //   if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
    //     result.classList.add('sticky')
    //   } else {
    //     result.classList.remove('sticky')
    //   }
    // }
  }

}
</script>

<style>
.menuliststyle{
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #DCDCDC;
  border-radius: 5px;
  padding: 5px;
  width: 80%;
  margin: auto;
  margin-bottom: 3px;
  font-weight: bold;
}
.title{
  text-align: center;
  font-size: 20px;
}
.menutextstyle{
text-transform: capitalize;
  cursor: pointer
}
.faviconstyle{
  font-size: 16px;
  margin-right: 5px;
  color: #ff3a52;
}
</style>

<!-- <style>
/* General Styles */
.menuliststyle {
  background: #ffffff;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 10px;
  font-weight: bold;
  text-align: center;
}

.menutextstyle {
  text-transform: capitalize;
  cursor: pointer;
}

.faviconstyle {
  color: #ff3a52;
}

.title {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

/* Mobile Header */
.mobilediv {
  display: none; /* Hidden by default for larger screens */
}

.toggle-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
}

/* Sidebar for Mobile */
.sidebar {
  position: fixed;
  top: 0;
  left: -300px;
  width: 250px;
  height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
  transition: all 0.3s ease;
  z-index: 999;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

.sidebar-open {
  left: 0;
}

/* Desktop Menu */
.menudivfixed {
  display: block; /* Visible by default */
}

/* Responsive Design */
@media (max-width: 768px) {
  /* Hide Desktop Menu */
  .menudivfixed {
    display: none;
  }

  /* Show Mobile Header */
  .mobilediv {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    background-color: #fff;
    /* border-bottom: 1px solid #ddd; */
  }

  /* Mobile Sidebar */
  .sidebar {
  position: fixed;
  top: 0;
  left: -300px;
  width: 250px;
  height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
  transition: all 0.3s ease;
  z-index: 999;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

.sidebar-open {
  left: 0;
}
}

</style> -->
<style>

/* Mobile Header */
.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #fff;
  /* border-bottom: 1px solid #ddd; */
  position: sticky;
  top: 0;
  z-index: 1000;
}

.mobile-title {
  font-size: 18px;
  font-weight: bold;
  color: #ff3a52;
}

.toggle-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
}

/* Sidebar */
.sidebar {
  position: fixed;
  top: 0;
  left: -300px;
  width: 250px;
  height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
  transition: all 0.3s ease;
  z-index: 9999;
  overflow-y: auto;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

.sidebar-open {
  left: 0;
}

.sidebar-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9998;
}

/* Sidebar Header */
.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.sidebar-title {
  font-size: 20px;
  font-weight: bold;
  color: #ff3a52;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #333;
  cursor: pointer;
}

/* Sidebar Menu */
.menuliststyle {
  background: #ffffff;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
  font-weight: bold;
  text-align: left;
}

.menutextstyle {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #333;
  font-size: 16px;
}

.menu-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

/* Prevent Scroll on Background */


/* Responsive */
@media (max-width: 768px) {
  .sidebar {
    width: 80%; /* Sidebar width for mobile */
    left: -100%;
  }
  .sidebar-open {
    left: 0;
  }
}

.menudivfixed {
  display: block; /* Visible by default */
}
.mobilediv {
  position: fixed;
  z-index: 1000;
  display: none; /* Hidden by default for larger screens */
}
.kycimage{
  display: block;
}
input[type="checkbox"] {
    margin-right: 5px;
    /* transform: scale(1.2); */
}
input[type="radio"] {
    margin-right: 5px;

}
.vs__selected{
  margin-right: 5px !important;
}


/* Responsive Design */
@media (max-width: 768px) {
  /* Hide Desktop Menu */
  .menudiv{
    z-index: 1000;
    position: fixed;
  }
  .menudivfixed {
    display: none;
  }
  .mobilediv {
  display: block; /* Hidden by default for larger screens */
}
.kycimage{
  display: none;
}
.navpad{
  margin-top: 30%;
  
}


}

</style>